<template>
    <a :href="href" class="btn btn-sm btn-default btn-icon ml-2" :target="targetBlank ? '_blank' : '_self'"
            @click="clicked" data-toggle="tooltip" data-theme="dark" :title="title">
        <i :class="icon"></i>
    </a>
</template>

<script>
export default {
    name: 'ActionButton',

    props: {
        icon: String,
        title: String,
        href: String,
        targetBlank: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        clicked() {
            this.$emit('click')
        },
    },
}
</script>
